<template>
	<div class="publish-page">
		<div class="publish-container">
			<h2 class="publish-title">发布分类信息</h2>
			<el-form ref="publishForm" :model="publishForm" :rules="publishRules" label-width="100px"
				class="publish-form">
				<!-- 信息分类 -->
				<el-form-item label="信息分类" prop="categoryId">
					<el-select @change="selectedCategory" v-model="publishForm.categoryId" placeholder="请选择分类"
						style="width: 100%;">
						<el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id" />
					</el-select>
				</el-form-item>

				<!-- 标题 -->
				<el-form-item label="信息标题" prop="title">
					<el-input v-model="publishForm.title" placeholder="请输入标题（不超过30字）" maxlength="30"
						show-word-limit></el-input>
				</el-form-item>

				<!-- 价格 -->
				<el-form-item label="价格" prop="price">
					<el-input v-model="publishForm.price" placeholder="请输入价格（元）" prefix-icon="el-icon-money">
						<template slot="append">元</template>
					</el-input>
				</el-form-item>

				<!-- 联系方式 -->
				<el-form-item label="联系电话" prop="phone">
					<el-input v-model="publishForm.phone" placeholder="请输入联系电话" maxlength="11"></el-input>
				</el-form-item>

				<!-- 详细描述 -->
				<el-form-item label="详细描述" prop="content">
					<el-input v-model="publishForm.content" type="textarea" placeholder="请输入详细描述（不超过500字）" rows="6"
						maxlength="500" show-word-limit></el-input>
				</el-form-item>


				<!-- 图片上传 -->
				<el-form-item label="上传图片" prop="images">
					<UploadImage v-model="publishForm.images" :max-count="5" @uploadSuccess='uploadImgSuccess'
						@handleRemove='handleRemoveImg' tip="最多上传5张图片，单张不超过2MB"></UploadImage>
				</el-form-item>

			</el-form>

			<div style="text-align: center;">
				<el-button type="primary" class="publish-btn" @click="handlePublish" :loading="loading">
					生成待支付订单发布信息
				</el-button>
			</div>
		</div>


		<el-dialog title="扫码支付" :visible.sync="dialogVisible" width="40%">

			<div style="font-size: 16px;">
				<div style="display: flex;flex-direction: row;">
					<span>信息标题:</span>
					<span style="margin-left: 10px;">{{publishForm.title}}</span>
				</div>

				<div style="display: flex;flex-direction: row;margin-top: 10px;">
					<span>订单编号:</span>
					<span style="margin-left: 10px;">{{orderResult.orderNo}}</span>
				</div>

				<div style="display: flex;flex-direction: row;margin-top: 10px;">
					<span>订单金额:</span>
					<span style="margin-left: 10px;color: red;">¥ {{publishForm.orderPrice}} 元</span>
				</div>

				<div style="height: 50px;" />

				<el-divider>
					<el-image style="width: 120px;" :src="require('@/assets/images/wechat.png')"></el-image>
				</el-divider>

				<div style="text-align: center;">
					<vue-qr ref="qrcode" :text="orderResult.codeUrl" :size="300" color="#333" bg-color="#fff"></vue-qr>
				</div>

				<div class="cls_tip_warning">
					<i class="el-icon-warning" style="font-size: 50px;color: red;" />
					<span style="color: #666666; margin-left: 10px;">
						<div>1.请扫码支付,不支持截图长安二维码支付</div>
						<div style="margin-top: 10px;">2.付费后,本信息需要管理员审核通过后,才能显示</div>
					</span>
				</div>
			</div>

			<!-- <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span> -->

		</el-dialog>


	</div>
</template>

<script>
	import {
		publishInfo,
		createNativeOrder
	} from '@/api/info'


	import {
		getCategoriesByParentId
	} from '@/api/category.js'

	import {
		uploadFile
	} from '@/api/upload.js'


	import {
		getUserInfo
	} from '@/api/user'


	import {
		validatePhone
	} from '@/utils/validate'

	import VueQr from 'vue-qr'

	import UploadImage from '@/components/UploadImage.vue'

	export default {
		name: 'Publish',
		components: {
			UploadImage,
			VueQr
		},
		data() {
			return {
				dialogVisible: false,
				loading: false,
				user: {},
				categoryList: [],
				orderResult: {
					codeUrl: "",
					orderNo: ''
				},
				qrText: 'www.baidu.com',

				// 上传成功后的图片ID
				imgsIds: [],
				// 发布表单
				publishForm: {
					categoryId: '',
					moduleId: '',
					title: '',
					price: '',
					orderPrice: '',
					phone: '',
					content: '',
					imgsIds: [],
					images: [],
					thumbnail: ''
				},
				// 表单验证规则
				publishRules: {
					categoryId: [{
						required: true,
						message: '请选择信息分类',
						trigger: 'change'
					}],
					title: [{
							required: true,
							message: '请输入信息标题',
							trigger: 'blur'
						},
						{
							max: 30,
							message: '标题长度不能超过30字',
							trigger: 'blur'
						}
					],
					phone: [{
							required: true,
							message: '请输入联系电话',
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (value && !validatePhone(value)) {
									callback(new Error('请输入正确的手机号'))
								} else {
									callback()
								}
							},
							trigger: 'blur'
						}
					],
					content: [{
							required: true,
							message: '请输入详细描述',
							trigger: 'blur'
						},
						{
							max: 500,
							message: '描述长度不能超过500字',
							trigger: 'blur'
						}
					]
				}
			}
		},



		/**
		 * 页面初始化
		 */
		mounted() {
			this.getUserInfo()
			this.getCategoriesByParentId()
		},




		methods: {


			// 重置表单
			resetForm() {
				this.$refs.publishForm.resetFields()
				this.publishForm.images = []
			},


			// 发布信息
			handlePublish() {
				this.$refs.publishForm.validate(async (valid) => {
					if (valid) {
						this.loading = true
						try {
							// // 基础信息
							const baseInfo = {
								'userId': this.user.id,
								'moduleId': this.publishForm.moduleId,
								'categoryId': this.publishForm.categoryId,
								'title': this.publishForm.title,
								'content': this.publishForm.content,
								'coverImages': this.publishForm.imgsIds.toString(),
								'thumbnail': this.publishForm.thumbnail
							}
							const dataInfo = {
								'base': baseInfo
							}
							const temp = await publishInfo(dataInfo)
							if (temp.code == 200) {
								const orderList = temp.data
								const orderInfo = {
									'money': 1,
									'cmsBaseId': orderList[0].baseId
								}
								const orderResult = await createNativeOrder(orderInfo)
								if (orderResult.code == 200) {
									this.dialogVisible = true
									this.orderResult = orderResult.data
								} else {
									this.$message.error('信息发布失败，请重试！')
								}
							} else {
								this.$message.error('信息发布失败，请重试！')
							}
						} catch (error) {
							console.log(error)
							this.$message.error('信息发布失败，请重试！')
						} finally {
							this.loading = false
						}
					}
				})
			},


			async getCategoriesByParentId() {
				const temp = await getCategoriesByParentId(0)
				if (temp.code == 200) {
					this.categoryList = temp.data
				}
			},



			async getUserInfo() {
				const temp = await getUserInfo()
				if (temp.code == 200) {
					this.user = temp.data
				}
			},


			/**
			 * @param {Object} value 切换
			 */
			selectedCategory(value) {
				this.categoryList.forEach(item => {
					if (item.id == value) {
						this.publishForm.moduleId = item.moduleId
						this.publishForm.orderPrice = item.unitPrice
					}
				})
			},


			/**
			 * @param {Object} value 图片上传成功
			 */
			async uploadImgSuccess(value) {
				this.imgsIds.push(value.ossId)
				this.publishForm.thumbnail = value.ossId
				this.imgsIds.forEach(item => {
					this.publishForm.imgsIds.push(item)
				})
			},



			/**
			 * @param {Object} value
			 * 删除其中的一张图片
			 */
			async handleRemoveImg(value) {
				this.imgsIds.forEach(item => {
					if (item != value.ossId) {
						this.publishForm.imgsIds.push(item)
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.publish-page {
		min-height: 100vh;
		background-color: #f5f5f5;
		padding: 30px 0;

		.publish-container {
			width: 800px;
			margin: 0 auto;
			padding: 30px;
			background-color: #fff;
			border-radius: 8px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

			.publish-title {
				margin-bottom: 20px;
				color: #009933;
				border-bottom: 1px solid #eee;
				padding-bottom: 10px;
			}
		}


		.publish-btn {
			width: 50%;
		}



		.cls_tip_warning {
			margin-bottom: 50px;
			margin-top: 20px;
			padding: 10px;
			display: flex;
			align-items: center;
			flex-direction: row;
			background-color: #f8f8f8;
		}
	}
</style>